import { render } from "./appSidebar.vue?vue&type=template&id=3186a1e7&scoped=true"
import script from "./appSidebar.vue?vue&type=script&lang=js"
export * from "./appSidebar.vue?vue&type=script&lang=js"

import "./appSidebar.vue?vue&type=style&index=0&id=3186a1e7&scoped=true&lang=css"

import exportComponent from "D:\\gitrepos\\QNBPayHelp\\apidocs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3186a1e7"]])

export default __exports__